import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, timeout, catchError, retry } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AlertService } from './alert.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GetJsonObjectService {
  constructor(
    private http: HttpClient,
    private alertService: AlertService,
  ) { }

  public dataOutput: any;

  private resolveUrl(url: string): string {
    const apiBaseUrl = environment.url.endsWith('/') ? environment.url : `${environment.url}/`;
    if (url.startsWith('/')) {
      return `${apiBaseUrl}${url.slice(1)}`;
    }
    return `${apiBaseUrl}${url}`;
  }

  getJson(url: string, responseType?: string, paramInput: any = null, selfCatchError: boolean = true): Observable<any> {
    let option: any = {};
    if (responseType != null) option['responseType'] = responseType as 'json';
    if (paramInput == null) option['params'] = null;
    else option['params'] = paramInput;
    if (url != '') {
      return this.http.get<any>(this.resolveUrl(url), option).pipe(
        retry(1),
        map((data: any) => {
          return data;
        }),
        catchError((e) => {
          if (selfCatchError) {
            return new Observable((observer) => {
              console.log('e : ', e);
              if (e.error?.title != null)
                this.alertService.error({ 
                  subType: '',
                  message: e.error?.title + ' (' + e.error?.detail + ') type error : ' + e.error?.status,
                });
              else {
                this.alertService.error({ //standard .net error
                  subType: '',
                  message: e.message + ', ' + e?.subtype,
                });
              }
              observer.next(null);
              observer.complete();
            });
          } else {
            return new Observable((observer) => {
              observer.next(e);
              observer.complete();
            });
          }
        }),
      );
    } else
      return new Observable((observer) => {
        observer.next(null);
        observer.complete();
      });
  }
}
